import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";


const $ = window.jQuery;
const triggerEvent = (photoGalleryAction, photoGalleryValue) => dataLayer.push({event: "post gallery", virtualPageURL: location.href, photoGalleryAction, photoGalleryValue});

const photoSwipeOptions = {
  bgOpacity: .85,
  closeOnScroll: false,
  timeToIdle: 0,
  shareButtons: [
    {id: "facebook", label: '<span class="icon-icon-facebook-1 fb-icon"></span>', url: `https://www.facebook.com/sharer/sharer.php?u={{url}}`},
    {id: "pinterest", label: '<span class="icon-weibo-1 weibo-icon"></span>', url: `https://service.weibo.com/share/share.php?title={{text}}&url={{url}}`},
    {id: "twitter", label: '<span class="icon-whatsapp-1 whatsapp-icon"></span>', url: `https://wa.me/?text={{url}}`},
    {id: "twitter", label: '<span class="icon-line-01 line-icon"></span>', url: `http://line.me/R/msg/text/?{{url}}`},
    {id: "download", label:'<span class="icon-link-1 link-icon"></span>', url:'{{url}}', download: true},
  ],
};
export default function Shegallery (reload) {
  if (reload ==0){
    const hash = window.location.hash;
    if (hash) {
      const pid = parseInt(hash.split("pid=")[1]) - 1;
      const gid = parseInt(hash.split("gid=")[1]);
      const $gallery = $($('.shegallery[data-shegallery-id="'+gid+'"]'));

      if ($gallery.length !== 0) {
        const guid = gid;
        const $pswp = $gallery.find(".pswp");
        const items = $gallery.data("shegallery-items").map(({original, title}) => ({...original, title}));
        const slideHistory = [pid];
        const photoSwipe = new PhotoSwipe($pswp.get(0), PhotoSwipeUI_Default, items, {index: pid, galleryUID: guid, ...photoSwipeOptions});
        photoSwipe.init();
      }
    }
  }
  $(".shegallery").not('.inited').each((index, gallery) => {
    const $gallery = $(gallery);
    const guid = $gallery.data("shegallery-id");
    const $preview = $gallery.find(".shegallery__preview");
    const $pswp = $gallery.find(".pswp");
    const $previewItems = $preview.find(".shegallery__preview-item");
    const items = $gallery.data("shegallery-items").map(({original, title}) => ({...original, title}));

    // Initializing
    $previewItems.each((index, previewItem) => {
      const $previewItem = $(previewItem);
      $previewItem.click(() => {
        const slideHistory = [index];
        const photoSwipe = new PhotoSwipe($pswp.get(0), PhotoSwipeUI_Default, items, {
          index,
          galleryUID: guid,
          ...photoSwipeOptions
        });

        photoSwipe.init();

        $(".ats-overlay-bottom-wrapper-rendered").css({zIndex: "999"});

        triggerEvent("open gallery", items[index].src);
        dataLayer.push({
          virtualPageTitle: document.title+" (Post Gallery)",
          virtualPageURL: window.location.pathname,
          event: "VirtualPageview",
        });

        // $pswp.find(".pswp__share--download").click((event, el) => {
        //   event.preventDefault();
        //   debugger;
        //   console.log("copying", $(el).attr("src"));
        // });

        // $pswp.on("click", ".pswp__share--download", (event) => {
        //   event.preventDefault();
        //   const $el = $(event.currentTarget);
        //   // const $tempInput = $(document.createElement("input")).css({position: "absolute", opacity: "0", border: "none", width: "1px", height: "1px"});
        //   const $tempInput = $(document.createElement("input")).css({position: "absolute", zIndex: 11111111});
        //   $tempInput.val($el.attr("src"));
        //   $(document.body).append($tempInput);
        //   $tempInput.focus().select();
        //   debugger;
        //   document.execCommand("copy");
        //   $tempInput.remove();
        //   console.log("hello, world");
        // })

        function listenFullScreenChange () {
          triggerEvent("fullscreen", items[index].src);
        }

        function listenWheel (event) {
          if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
            photoSwipe.prev();
          } else {
            photoSwipe.next();
          }
        }

        $(window).on("wheel", listenWheel);

        $(document).on("fullscreenchange", listenFullScreenChange);

        photoSwipe.listen("beforeChange", () => {

        });

        photoSwipe.listen("afterChange", () => {
          const lastIndex = slideHistory[slideHistory.length - 1];
          const currentIndex = photoSwipe.getCurrentIndex();
          if (lastIndex === 0) {
            if (currentIndex === 1) { triggerEvent("next", photoSwipe.currItem.src); }
            else { triggerEvent("previous", photoSwipe.currItem.src); }
          } else if (lastIndex === items.length - 1) {
            if (currentIndex === 0) { triggerEvent("next", photoSwipe.currItem.src); }
            else { triggerEvent("previous", photoSwipe.currItem.src); }
          } else {
            if (currentIndex - lastIndex === 1) { triggerEvent("next", photoSwipe.currItem.src); }
            else { triggerEvent("previous", photoSwipe.currItem.src); }
          }
          slideHistory.push(currentIndex);
          triggerEvent("photo", photoSwipe.currItem.src);
          dataLayer.push({
            virtualPageTitle: document.title+" (Post Gallery)",
            virtualPageURL: window.location.pathname,
            event: "VirtualPageview",
          });
        });

        photoSwipe.listen('shareLinkClick', function(event, target) {
          const $target = target.tagName === "SPAN" ? $(target).parent() : $(target);
          target = $target.get(0);

          // Doing Google Analytics
          {
            const shareClass = [...target.classList].find(classItem => classItem.includes('pswp__share--'));
            const shareItem = typeof shareClass === "string" ? shareClass.replace('pswp__share--', '').replace('download', 'copylink') : null;
            if (typeof shareItem === "string" && shareItem) { triggerEvent(shareItem, photoSwipe.currItem.src); }
          }


          // Copy link instead of really downloading
          if ($target.hasClass("pswp__share--download")) {
            event.preventDefault();
            const $tempInput = $(document.createElement("input")).css({position: "absolute", zIndex: 11111111, opacity: "0", width: 1, height: 1, border: "none"});
            $tempInput.val(unescape($target.attr("href")));
            $(document.body).append($tempInput);
            $tempInput.focus().select();
            document.execCommand("copy");
            $tempInput.remove();
          }
        });

        photoSwipe.listen("destroy", () => {
          triggerEvent("close gallery", photoSwipe.currItem.src);
          $(window).off("wheel", listenWheel);
          $(document).off("fullscreenchange", listenFullScreenChange);
          if ($(".ats-overlay-bottom-wrapper-rendered").length !== 0) {
            $(".ats-overlay-bottom-wrapper-rendered").get(0).style.zIndex = '';
          }
        });

      });
    });

    // Showing the "see more" on the 5th item
    const updateItemMoreStatus = () => {
      $previewItems.removeAttr("data-item-more");

      /** when it's `1-large` template mode **/
      if ($gallery.hasClass("shegallery--1-large")) {
        if (window.innerWidth >= 998) {
          if (items.length > 6) { $previewItems.eq(4).attr("data-item-more", items.length - 4); }
        } else {
          if (items.length > 5) { $previewItems.eq(3).attr("data-item-more", items.length - 3); }
        }
      }

      /** when it's `2-larges` template mode **/
      else if ($gallery.hasClass("shegallery--2-larges")) {
        if (window.innerWidth >= 998) {
          if (items.length > 7) { $previewItems.eq(5).attr("data-item-more", items.length - 5); }
        } else {
          if (items.length > 6) { $previewItems.eq(4).attr("data-item-more", items.length - 4); }
        }
      }

      /** when it's `2-larges` template mode **/
      else if ($gallery.hasClass("shegallery--2-rows")) {
        if (window.innerWidth >= 998) {
          if (items.length > 9) { $previewItems.eq(7).attr("data-item-more", items.length - 7); }
        } else {
          if (items.length > 7) { $previewItems.eq(5).attr("data-item-more", items.length - 5); }
        }
      }

      /** when it's basic template mode, or `row` mode **/
      else {
        if (window.innerWidth >= 998) {
          if (items.length > 5) { $previewItems.eq(3).attr("data-item-more", items.length - 3); }
        } else {
          if (items.length > 4) { $previewItems.eq(2).attr("data-item-more", items.length - 2); }
        }
      }
    };

    $(window).on("resize", updateItemMoreStatus);
    updateItemMoreStatus();
    $gallery.addClass('inited');
  });
}



// WEBPACK FOOTER //
// ./src/Shegallery.js